export default "__VITE_ASSET__BU2tvRgy__"